module.exports = __webpack_public_path__ + "static/img/icon_news_close.198692a4.svg";